import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";

const GestionCompetencesPresta = () => {
    const { prestataire } = useSelector((state) => state.profil);
    const { token } = useSelector((state) => state.auth);
    const [secteurs, setSecteurs] = useState([]);
    const [selectedSecteur, setSelectedSecteur] = useState(null);
    const [competence, setCompetence] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;
    const urlImgsMetier = apiUrl + "/api/files/?categorie=metiers&file=";
    const dispatch = useDispatch();

    const refreshSecteurs = useCallback(() => {
        setLoading(true);
        fetch(`${apiUrl}/api/secteurs`)
            .then((res) => res.json())
            .then((data) => {
                setSecteurs(data);

                if (prestataire?.secteur) {
                    const secteurFromApi = data.find(
                        (s) => s.idSecteur === prestataire.secteur.idSecteur
                    );
                    if (secteurFromApi) setSelectedSecteur(secteurFromApi);
                }
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [apiUrl, prestataire]);

    useEffect(() => {
        refreshSecteurs();
    }, [refreshSecteurs]);

    const handleAddCompetence = async () => {
        if (!competence) return;

        const formData = new FormData();
        formData.append("idMetier", competence.idMetier);

        try {
            const response = await fetch(`${apiUrl}/api/updateProfil/addCompetencePrestataire`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                alert(data.message || "Erreur lors de l'ajout");
                return;
            }

            dispatch(fetchProfilPrestataire(token));
            setCompetence(null);
            setShowOverlay(false);

        } catch (error) {
            console.error("Erreur ajout :", error);
            alert("Impossible d'ajouter cette compétence.");
        }
    };

    const handleDeleteCompetence = async (idMetier) => {
        if (!window.confirm("Supprimer cette compétence ?")) return;

        const formData = new FormData();
        formData.append("idMetier", idMetier);

        try {
            const response = await fetch(`${apiUrl}/api/updateProfil/deleteCompetencePrestataire`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                alert(data.message || "Erreur lors de la suppression");
                return;
            }

            dispatch(fetchProfilPrestataire(token));

        } catch (error) {
            console.error("Erreur suppression :", error);
            alert("Impossible de supprimer cette compétence.");
        }
    };

    return (
        <div style={{margin:"auto",display:"flex",flexDirection:"column",justifyContent:"center"}}>
            {/* BOUTON POUR OUVRIR L'OVERLAY */}
            <button
                onClick={() => setShowOverlay(true)}
                style={{
                    padding: "10px 18px",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    marginBottom: "20px",
                    cursor: "pointer",
                }}
            >
                Ajouter une compétence
            </button>

            {/* OVERLAY */}
            {showOverlay && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            background: "white",
                            padding: "20px",
                            borderRadius: "10px",
                            width: "400px",
                            position: "relative",
                        }}
                    >
                        {/* BOUTON FERMETURE OVERLAY */}
                        <FontAwesomeIcon
                            icon={faTimes}
                            onClick={() => setShowOverlay(false)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                                color: "#444",
                            }}
                        />

                        <h3>Ajouter une compétence</h3>

                        {loading && <p>Chargement...</p>}

                        {/* CHOIX SECTEUR */}
                        <label>Secteur :</label>
                        <select
                            value={selectedSecteur?.idSecteur || ""}
                            onChange={(e) => {
                                const selected = secteurs.find(
                                    (s) => s.idSecteur === parseInt(e.target.value, 10)
                                );
                                setSelectedSecteur(selected || null);
                                setCompetence(null);
                            }}
                            style={{ width: "100%", marginBottom: "15px" }}
                        >
                            <option value="">-- Choisir --</option>
                            {secteurs.map((s) => (
                                <option key={s.idSecteur} value={s.idSecteur}>
                                    {s.labelSecteur}
                                </option>
                            ))}
                        </select>

                        {/* CHOIX COMPÉTENCE */}
                        {selectedSecteur && (
                            <>
                                <label>Compétence :</label>
                                <select
                                    value={competence?.idMetier || ""}
                                    onChange={(e) => {
                                        const metier = selectedSecteur.metiers.find(
                                            (m) => m.idMetier === parseInt(e.target.value, 10)
                                        );
                                        setCompetence(metier || null);
                                    }}
                                    style={{ width: "100%", marginBottom: "15px" }}
                                >
                                    <option value="">-- Choisir --</option>
                                    {selectedSecteur.metiers.map((m) => (
                                        <option key={m.idMetier} value={m.idMetier}>
                                            {m.labelMetier}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    onClick={handleAddCompetence}
                                    disabled={!competence}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        background: "#28a745",
                                        border: "none",
                                        color: "white",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Ajouter
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* LISTE DES COMPÉTENCES EXISTANTES */}
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "12px",
                    marginTop: "20px",
                }}
            >
                {prestataire.competences.map((comp) => (
                    <div
                        key={comp.idMetier}
                        style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            borderRadius: "8px",
                            width: "100px",
                            textAlign: "center",
                            position: "relative",
                        }}
                    >
                        <img
                            src={urlImgsMetier + comp.iconMetier}
                            alt="icone métier"
                            style={{ width: "40px", height: "40px" }}
                        />
                        <p style={{ fontSize: "13px" }}>{comp.labelMetier}</p>

                        <FontAwesomeIcon
                            icon={faTrash}
                            onClick={() => handleDeleteCompetence(comp.idMetier)}
                            style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                cursor: "pointer",
                                color: "#c00",
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GestionCompetencesPresta;
